export const SET_CURRENT_TAB_STATE = 'SET_CURRENT_TAB_STATE'


export function setCurrentTabState (currentState) {
  return {
    type: SET_CURRENT_TAB_STATE,
    payload: currentState
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Announcement/redux/actions/setCurrentTabState.js